// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.progress[data-v-91ada908] {list-style: none;margin: 0;padding: 0;display: flex;align-items: center;border-radius: 8px;overflow: hidden;width: 263px;}\n.progressItem[data-v-91ada908] {background-color: var(--color-dark-pastel-green);width: 100%;height: 4px;}\n.progressItem.active ~ li[data-v-91ada908] {background-color: var(--color-pale-grey);}\n", ""]);
// Exports
module.exports = exports;
